import angular from 'angular';
import InquiryContactsListComponent from './inquiry-contacts-list-component';

export default angular.module('inquiry-contacts-list', []).component('inquiryContactsList', new InquiryContactsListComponent());



// WEBPACK FOOTER //
// ./src/modules/contact/components/inquiry-contacts-list/inquiry-contacts-list-module.js